
const axios = require("axios");

const menuOutOfStockUrl = process.env.prefix_menu_out_of_stock;

axios.getMenuOutOfStockList = function(params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/oos${params ? '?' + params : ''}`, { headers })
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuOutOfStockSearch = function(params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/product${params ? '?' + params : ''}`, { headers })
    .then(response => success(response))
    .catch((error) => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          error.response.data['statusCode'] = error.response.status
          callBackError(error.response.data)
        }
      }
    })
}

axios.addItemOutOfStock = function(payload, headers, success, callBackError) {
  this.post(`${menuOutOfStockUrl}/oos`, payload, { headers })
  .then(response => success(response))
  .catch(error => {
    if (error.response) {
      if (typeof callBackError !== 'undefined') {
        error.response.data['statusCode'] = error.response.status
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeItemFromOutOfStock = function(payload, headers, success, callBackError) {
  this.put(`${menuOutOfStockUrl}/oos`, payload, { headers })
    .then(response => success(response))
    .catch(error => {
      if (error.response) {
        if (typeof callBackError !== 'undefined') {
          error.response.data['statusCode'] = error.response.status
          callBackError(error.response.data)
        }
      }
    })
}

axios.exportMenuOutOfStockList = function(params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/export/oos${params ? '?' + params : ''}`, { headers })
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getRelatedDealList = function(params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/product/deal${params ? '?' + params : ''}`, { headers })
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportMenuOutOfStockGroupByStore = function(params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/export/oos/group-by-store${params ? '?' + params : ''}`, { headers })
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getAvailableDealsList = function(headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/oos/optional-deals`, { headers })
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateStatusAvailableDeals = function(payload, headers, success, callBackError) {
  this.put(`${menuOutOfStockUrl}/oos/opt-in-opt-out`, payload, { headers })
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportDealLive = function (params, headers, success, callBackError) {
  this.get(`${menuOutOfStockUrl}/export/deal-live?${params}`, { headers })
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.clearCache = function (success, callBackError) {
  this.delete(`${menuOutOfStockUrl}/cache/remove-all-cache`)
    .then(response => {
      success(response)
    })
    .catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/MenuOutOfStock.js